/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Current_ImageInputs */

const en_current_image = /** @type {(inputs: Current_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Image`)
};

const es_current_image = /** @type {(inputs: Current_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagen actual`)
};

/**
* | output |
* | --- |
* | "Current Image" |
*
* @param {Current_ImageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const current_image = /** @type {((inputs?: Current_ImageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_ImageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_current_image(inputs)
	return es_current_image(inputs)
});